export const ERRORBOX_MESSAGE = {
  notAvailable: 'Leider ist unser System im Moment nicht verfügbar. Bitte versuchen Sie es später noch einmal.',
  dataNotFound: 'Die Daten wurden nicht gefunden.',
  habError: 'habError',
  serviceError: 'serviceDown',
};
